/**
 * Return the translation string or object given a key in dot notation.
 * @param {string} key - Dot notation location of translation key
 * @param {string=} [locale=this.$store.state.locale] - (Optional) locale for translation e.g. 'en' or 'zh-HK'
 * @param {Object=} [messages=this.locales] - (Optional) messages object with top level locale objects of translation strings
 *
 * @returns {(string|Object|Array)} translation string
 */
export function t(key, locale, messages) {
	try {
		const currentLocale = locale || this?.$store?.state?.locale || "en"
		const localeMessages = (messages && messages[locale]) || (this.locales && this.locales[currentLocale]) || {}

		if (!key || typeof key !== "string") throw new Error("missing/invalid translation key")
		return key.split(".").reduce(function stringDotNotationReducer(obj, oKey) {
			if (!obj[oKey]) throw new Error(`Translation key ${key} does not exist [at ${oKey}].`)
			return obj[oKey] || key
		}, localeMessages)
	} catch (e) {
		// eslint-disable-next-line no-console
		console.warn(e)
		return key || ""
	}
}

/**
 * Returns name of particular value in an array of objects like so {name: "Female", value: "female"}
 * @param {String|Boolean|Number} value - value you need to get localised name
 * @param {Array} array - array of objects where to find the value
 * @param {String} valueKey - in the object name of the key for value {name: "Female", [valueKey]:"female"}
 * @param {String} nameKey - in the object name of the key for name {[nameKey]: "Female", value: "female"}
 *
 * @returns {String} - returns name key of the found object from the array
 */
export function tFromArray(value = "", array = [], valueKey = "value", nameKey = "name") {
	try {
		if (!array || !value || !Array.isArray(array)) return ""

		const found = array.find(item => item[valueKey] === value)
		if (!found) return ""

		return found[nameKey]
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error(e)
	}
}
